import { DeliveryProviderService } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProvider';
import type { RefreshTokenRequest } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProvider/models';

import { Gateway } from '@bolteu/react-api-gateway/es';

import { LocaleType } from '../../utils/translations_types';
import ProviderSignupSource = DeliveryProviderService.ProviderSignupSource;
import ProviderLifecycleStatus = DeliveryProviderService.ProviderLifecycleStatus;

// eslint-disable-next-line @typescript-eslint/no-empty-interface -- required by the API structure
export interface GetAccountInfoRequest {}

export interface GetAccountInfoResponse {
  account_info: GetAccountInfo;
}

export interface GetAccountInfo {
  account_data: AccountData;
  assignments: AssignedProviders[];
  has_async_reporting_feature_flag?: boolean;
}

export interface AccountData {
  first_name: string;
  last_name: string;
  email: string;
  is_account_onboarding?: boolean;
  is_account_email_confirmed: boolean;
}

export interface AssignedProviders {
  provider_id: number;
  provider_name: string;
  vendor_id: number;
  vendor_name: string;
  city_id: number;
  country_code: string;
  currency: CurrencyDetails;
  price_format_setting: PriceFormatSetting | null;
  city_locales: LocaleType[];
  city_main_locale: LocaleType;
  food_partner_portal_setup: FoodPartnerPortalSetup;
  /* deprecated */
  has_menu_editor?: boolean;
  menu_editor_settings?: MenuEditorSettings;
  dine_in_settings: DineInSettings;
  deductions_report_settings: DeductionsReportSettings;
  new_merchant_venue_settings: NewMerchantVenueSettings;
  signup_source: ProviderSignupSource;
  lifecycle_status: ProviderLifecycleStatus;
}

export interface FoodPartnerPortalSetup {
  can_self_assign_campaign: boolean;
  can_manage_promotions: boolean;
  is_menu_inflation: boolean;
  is_metrics_satisfied: boolean;
  can_manage_smart_promotions: boolean;
}

export interface MenuEditorSettings {
  is_enabled: boolean;
  has_alcohol_min_age_configured: boolean;
}

export interface DineInSettings {
  is_pay_and_go_enabled: boolean;
  is_order_and_pay_enabled: boolean;
}

export interface DeductionsReportSettings {
  is_deductions_report_enabled: boolean;
}

export interface CurrencyDetails {
  code: string;
  symbol: string;
}

export interface PriceFormatSetting {
  locale: string;
  options: {
    [option: string]: string;
  };
}

export interface NewMerchantVenueSettings {
  is_enabled: boolean;
}

export class DeliveryProviderAuthApi extends Gateway {
  public logout(refreshToken: string): Promise<void> {
    return this.postJSON<RefreshTokenRequest, void>(`/deliveryProviderPortal/logout`, {
      refresh_token: refreshToken,
    });
  }

  public getAccountInfo(): Promise<GetAccountInfoResponse> {
    return this.get<GetAccountInfoRequest, GetAccountInfoResponse>(
      `/deliveryProviderPortal/getAccountInfo`,
      {},
    );
  }
}
